/**
 * The screen-edge docks (spec 2026-10-08-kiosk-web-split §5): the pending-payments floater
 * (PendingTransactionFloater) docks to the left edge and the side strip (SideStrip) to the right.
 * One module places both so they never overlap: the same layer (`z-floating`: above the page and
 * its chrome, below dialogs, popovers and toasts), the same vertical anchor (mid-height), opposite
 * edges. Both are mounted in App, the floater after the strip, so the floater's open panel (which
 * can reach the right edge on a phone) paints over the strip's handle, never under it.
 * The container ignores pointer events; each dock's own control takes them.
 */
export const EDGE_DOCK_CLASS = {
  left: 'pointer-events-none fixed left-0 top-1/2 z-floating flex -translate-y-1/2 items-center',
  right: 'pointer-events-none fixed right-0 top-1/2 z-floating flex -translate-y-1/2 items-center justify-end',
} as const;
